if (!customElements.get('word-collection-slider')) {
  class WordCollectionSlider extends HTMLElement {
    constructor() {
      super();
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.triggers = Array.from(this.querySelectorAll('[data-word-trigger]'));
      this.slides = Array.from(this.querySelectorAll('[data-word-slide]'));
      this.track = this.querySelector('[data-slide-track]');
      this.shopNowButton = this.querySelector('[data-shop-now]');
      this.desktopMq = window.matchMedia('(min-width: 768px)');

      if (!this.triggers.length || !this.slides.length || !this.track) return;

      this.triggers.forEach((trigger) => {
        const index = Number(trigger.dataset.index);

        trigger.addEventListener('mouseenter', () => {
          if (this.isDesktop()) this.setActive(index);
        });

        trigger.addEventListener('focus', () => {
          if (this.isDesktop()) this.setActive(index);
        });

        trigger.addEventListener('click', (event) => this.handleTriggerClick(event, index));
      });

      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
      }

      const initialIndex = Number(this.dataset.initialIndex);
      if (Number.isInteger(initialIndex) && initialIndex >= 0) {
        this.setActive(initialIndex, false);
      } else {
        this.setActive(0, false);
      }
    }

    disconnectedCallback() {
      if (window.Shopify && window.Shopify.designMode) {
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }
    }

    isDesktop() {
      return this.desktopMq.matches;
    }

    handleTriggerClick(event, index) {
      const trigger = this.triggers[index];
      if (!trigger) return;

      const url = trigger.dataset.url;
      if (this.isDesktop() && url) {
        return;
      }

      event.preventDefault();
      this.setActive(index);
    }

    handleBlockSelect(event) {
      const block = event.target.closest('[data-word-block]');
      if (!block || !this.contains(block)) return;

      const index = Number(block.dataset.index);
      if (Number.isInteger(index)) {
        this.setActive(index, false);
      }
    }

    setActive(index, allowMobileScroll = true) {
      if (!Number.isInteger(index) || index < 0 || index >= this.triggers.length) return;

      this.dataset.currentIndex = String(index + 1);
      this.track.style.transform = `translateX(-${index * 100}%)`;

      this.triggers.forEach((trigger, triggerIndex) => {
        const isActive = triggerIndex === index;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === index;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      if (this.shopNowButton) {
        const activeUrl = this.triggers[index].dataset.url;
        if (activeUrl) {
          this.shopNowButton.href = activeUrl;
          this.shopNowButton.classList.remove('is-disabled');
          this.shopNowButton.removeAttribute('aria-disabled');
        } else {
          this.shopNowButton.href = '#';
          this.shopNowButton.classList.add('is-disabled');
          this.shopNowButton.setAttribute('aria-disabled', 'true');
        }
      }

      if (allowMobileScroll && !this.isDesktop()) {
        this.triggers[index].scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        });
      }
    }
  }

  customElements.define('word-collection-slider', WordCollectionSlider);
}
